// [원본 복원] 전개발자 구조 유지. 얹은 것: ①지문분석 선택 색 ②모바일 사이즈 ③넘침 차단
const VocaMatchingCard = ({ selectedIndex, word, handleClick, type }) => {
  const m = Math.min(window.innerWidth, window.screen.width) <= 768;
  const isSelected = selectedIndex === word.index;
  const isMatched = word.isMatched;
  return (
    <div
      key={word.text}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // 데스크톱은 컨테이너 기준(위 VocaStudyCard 와 같은 이유)
        width: m ? "16vw" : "calc(20% - 8px)",
        minWidth: 0,
        minWidth: m ? "56px" : undefined,
        height: m ? "70px" : "25vh",
        // [수정] overflow:hidden은 원본에 없던 것 — 좁은 칸에서 단어의
        // 양끝 글자를 깎았다("carelessly"→"relessly"). 원본대로 자연 줄바꿈에 맡긴다.
        border: "1px solid #EBEBEB",
        boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
        borderRadius: "10px",
        padding: m ? "4px" : "10px",
        boxSizing: "border-box",
        fontSize: m ? "11px" : "20px",
        backgroundColor:
          (isSelected || isMatched) &&
          (type === "analysis" ? "#E5FBF8" : "#EBEBEB"), // ①지문분석만 ECHO
        transition: "background-color 0.5s ease",
        textAlign: "center",
      }}
      onClick={() => {
        if (isMatched) return;
        handleClick(word.index);
      }}
    >
      <div
        style={{
          // 긴 뜻이 카드 밖으로 삐져나와 잘려 보였다. 카드 크기는 그대로 두고
          // **넘치는 것만 카드 안에서 스크롤한다.** 짧으면 가운데 그대로다.
          maxHeight: "100%",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          whiteSpace: "normal",
        }}
      >
        {word.text}
      </div>
    </div>
  );
};

export default VocaMatchingCard;
